const Footer = () => {
    return ( 
        <div className="footer-section">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="footer-content text-center">
                            <h6>Design and Developed with <span className="">🙂</span>By Rakib</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     );
}
 
export default Footer;